export default {
    'PNB' : 'images/PNB.svg',
    'UPI' : 'images/UPI.svg',
    'PayTm' : 'images/paytm_icon.svg',
    'Google Pay' : 'images/gpay_icon.svg',
    'Gpay' : 'images/gpay_icon.svg',
    'PhonePay' : 'images/phone_pay.svg',
    'Sbi'   : 'images/sbi.svg',
    'BHIM' : '/images/bharat_pay.svg',
    'BHIM UPI' : '/images/bharat_pay.svg',
    'BharatPay' : '/images/bharat_pay.svg',
    'hdfc': 'images/hdfc.svg',
    'icic' : 'images/Icici.svg',
    'bob': 'images/bob.svg',
    'KotatMahindra' : 'images/kotak_mahindra.svg',
    'QuestionMark' :'images/question_mark.svg',
    'BackArrow' : 'images/Back_Arrow.svg',
    'InfoIcon' : 'images/info_icon.svg',
    'BarCode' : 'images/barcode.svg',
    'pblogo' : 'images/pb_logo.svg',
    'closeBtn' : 'images/closebtn.svg',
    'payPal' : 'images/paypal.svg',
    'BarCodeBG' : 'images/bar_code_bg.png',
    'barcode' : 'images/barcode.png',
    'easyEmi': 'images/easy-emi.svg',
    'creditCard' : 'images/credit-card.svg',
    'wallet' : 'images/wallet.svg',
    'netbanking' : 'images/netbanking.svg',
    'UpiIcon' : 'images/UPI.svg',
    'Amazon Pay' : 'images/amazonPay.svg',
    'PhonePe' : 'images/phonePay.svg',
    'Airtel Money' : 'images/airtelIcon.svg',
    'Jio Money' : 'images/jioMoney.svg',
    'FreeCharge Wallet' : 'images/freeCharge.svg',
    'Paytm' : 'images/payTmnew.svg',
    'notesIcon' : 'images/notesIcon.svg',
    'bankBg' : 'images/account_balance_bg.svg',
    'cvvBg' : 'images/cvv_card.svg',
    'pos': 'images/pos.svg',
    'posActive': 'images/pos_active.svg',
    'Mobikwik' : 'images/mobikwick.svg',
    'Oxigen Wallet' : 'images/oxygen.svg',
    'PAYZAPP' : 'images/payZap.svg',
    'OLA Money': 'images/olaMoney.svg',
    'copyBtn' : 'images/copyBtn.svg',
    'BajajFinserv' : 'images/Bajaj_Finserv.svg',
    'Axio' : 'images/Axio.svg',
    'ShopSe' : 'images/ShopSe.svg',
    'pgBarCode' : 'images/pg_barcode.png',
    'closeBtn' : 'images/close_btn.svg',
    'amazonPayLogo' : 'images/amazon_pay.svg',
    'Razorpay Wallet' : 'images/razorpay-logo.svg',
    'Payment Failed' : 'images/alert_icon.png',
    'EarlySalary' : 'images/earlysalary.svg',
    'QR Emandate' : 'images/qr-wrapper.svg',
    'Emandate Banner' : 'images/emandate-banner.svg',
    'LazyPay' : 'images/LazyPay.svg'



}
